import { IDonateBonus } from "@interfaces/user/payments";
import { createContext, useContext } from "react";

const DonateBonusContext = createContext<IDonateBonus>(undefined as any);
export const DonateBonusProvider = DonateBonusContext.Provider;

export function useDonateBonusContext(): IDonateBonus | undefined {
    return useContext(DonateBonusContext);
}